import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { getPatchProcessing } from '../../../../ng2/store/selectors/processing-update-selector';
@Injectable()
export class ProcessingUpdateResolver {
  resolvePatchProcessing$(store): Promise<Observable<any>> {
    const destroy$: Subject<boolean> = new Subject<boolean>();

    return new Promise(resolve => {
      store
        .select(getPatchProcessing)
        .takeUntil(destroy$)
        .subscribe(() => {
          const currentlyLoading$ = store.select(getPatchProcessing);
          destroy$.next(true);
          destroy$.unsubscribe();
          resolve(currentlyLoading$);
        });
    });
  }
}
